import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeDot',
  standalone: true,
})
export class RemoveDotPipe implements PipeTransform {
  transform(value: string | null): any {
    if (!value) {
      return '';
    }
    return value.replace(/['.']/g, '');
  }
}
